import type { Content } from '@/modules/Content/interface/Content';
import type { FC } from 'react';
import {
  Flex,
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
} from '@eqi-investimentos/react';
import { SupplementaryMaterials } from '@/modules/Research/ui/SupplementaryMaterials';
import { IfRender } from '@/utils/jsx';
import { AboutSection } from './AboutSection';
import { ClassesSection } from './ClassesSection';

export const EducationalSection: FC<EducationalSectionProps> = ({
  content,
  programType,
  t,
}) => {
  return (
    <IfRender condition={programType === 'educational'}>
      <Flex direction="column" gap="6xl" color="content.primary" w="full">
        <Tabs display="flex" flexDir="column" w="full" gap="l">
          <TabList p="0" w="fit-content">
            <Tab>{t('screens.content.educational.tabsBar.classes')}</Tab>
            <Tab>{t('screens.content.educational.tabsBar.description')}</Tab>
          </TabList>
          <TabPanels p="0">
            <TabPanel>
              <ClassesSection seasons={content.seasons} />
            </TabPanel>
            <TabPanel>
              <AboutSection content={content} />
            </TabPanel>
          </TabPanels>
        </Tabs>
        <SupplementaryMaterials files={content.files} />
      </Flex>
    </IfRender>
  );
};

type EducationalSectionProps = {
  content: Content;
  programType: string;
  t: (key: string) => string;
};
